import React, { createContext, useContext, useState, useCallback } from 'react';
import type { MenuNode } from '@/config/menuStructure';

interface SubmenuSidebarContextType {
  openNode: MenuNode | null;
  openSubmenu: (node: MenuNode | null) => void;
  closeSubmenu: () => void;
}

const SubmenuSidebarContext = createContext<SubmenuSidebarContextType | undefined>(undefined);

export const useSubmenuSidebar = () => {
  const context = useContext(SubmenuSidebarContext);
  if (context === undefined) {
    throw new Error('useSubmenuSidebar must be used within a SubmenuSidebarProvider');
  }
  return context;
};

interface SubmenuSidebarProviderProps {
  children: React.ReactNode;
}

export const SubmenuSidebarProvider = ({ children }: SubmenuSidebarProviderProps) => {
  const [openNode, setOpenNode] = useState<MenuNode | null>(null);
  const openSubmenu = useCallback((node: MenuNode | null) => setOpenNode(node), []);
  const closeSubmenu = useCallback(() => setOpenNode(null), []);

  return (
    <SubmenuSidebarContext.Provider
      value={{
        openNode,
        openSubmenu,
        closeSubmenu,
      }}
    >
      {children}
    </SubmenuSidebarContext.Provider>
  );
};
